import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          观众热评
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          听听综艺爱好者们的真实声音
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {commentsData.map((item) => (
            <div
              key={item.id}
              className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.style.display = 'none';
                    }}
                  />
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                    {item.name}
                  </div>
                  <div className="text-xs text-foreground-400 whitespace-nowrap">
                    {item.role}
                  </div>
                </div>
                <div className="ml-auto flex items-center gap-0.5 flex-shrink-0">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i
                      key={i}
                      className={`text-xs ${i < item.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                    ></i>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                "{item.content}"
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}